import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
    return (
        <div>
            {/* <Link to={'/allData'}> See All Data </Link> */}

            <Button size='large' variant='contained' color='primary' component={Link} to='/expenses'> Expenses </Button>
            
        </div>
    );
};

export default HomePage;